import React, { useEffect } from "react";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import {
  Grid,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
} from "@mui/material";
import MarkEmailUnreadOutlinedIcon from "@mui/icons-material/MarkEmailUnreadOutlined";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import PushPinIcon from "@mui/icons-material/PushPin";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import {
  getNoticesResponse,
  noticeDetailRequest,
} from "../../models/SupplierNotice.model";
import { useMutation } from "react-query";
import { GetNoticeDetail } from "../../services/SupplierNotice.service";
import ModalNotice from "../../components/modals/ModalNotice";

export default function NotifChild({ value }: any) {
  const [hoverRow, setHoverRow] = React.useState<boolean>(false);
  const [modalDetail, setModalDetail] = React.useState<getNoticesResponse[]>(
    []
  );
  const [pinColor, setPinColor] = React.useState(value.isPinned);
  const [openModal, setOpenModal] = React.useState(false);
  const [viewDate, setViewDate] = React.useState(value.viewDate);
  const FNsetViewDate = () => {
    setViewDate("null");
  };
  useEffect(() => {
    setPinColor(value.isPinned);
  }, [value.isPinned]);
  useEffect(() => {
    setViewDate(value.viewDate);
  }, [value.viewDate]);
  const handleMouseOver = () => {
    setHoverRow(true);
  };
  const handleMouseOut = () => {
    setHoverRow(false);
  };

  const handleShowDetailModal = (noticeKey: any) => {
    const noticeId = new noticeDetailRequest();
    noticeId.noticeKey = noticeKey;
    if (noticeId) {
      getNoticeDetailMutation.mutateAsync(noticeId);
    }
  };
  const getNoticeDetailMutation = useMutation(GetNoticeDetail, {
    onSuccess: (data: getNoticesResponse[]) => {
      if (data) {
        setModalDetail(data);
        setOpenModal(true);
      }
    },
  });
  return (
    <>
      <Grid
        className={`${
          value.noticeType == "Instant"
            ? viewDate
              ? "borderBeforCardHistoryViewImportant"
              : "borderBeforCardHistoryImportant"
            : viewDate
            ? "borderBeforCardHistoryViewInfo"
            : "borderBeforCardHistoryInfo"
        } `}
        container
        spacing={2}
        item
        xs={12}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      >
        <ListItem
          alignItems="flex-start"
          // divider={index < carrierDetails.length - 1}
          onClick={() => handleShowDetailModal(value.noticeKey)}
          className="cursorPointer"
        >
          <ListItemAvatar>{value.title}</ListItemAvatar>
          <ListItemText
            primary={value.carrierName}
            secondary={
              <React.Fragment>
                <Stack
                  direction="column"
                  spacing={1}
                  // onClick={() => handleShowDetailModal(value.noticeKey)}
                  className="cursorPointer"
                >
                  {!hoverRow ? (
                    <div
                      className={
                        value.noticeType == "Instant"
                          ? "colorImportantOld disableForm"
                          : "colorInfoOld disableForm"
                      }
                    >
                      <span>
                        <b>
                          {value?.noticeTypePersian}&nbsp;- &nbsp;
                          {value.creationDatePersian}
                        </b>{" "}
                      </span>{" "}
                      &nbsp; | &nbsp;
                      <b>
                        <AttachFileIcon /> {value.attachmentCount}
                      </b>
                    </div>
                  ) : (
                    <div
                      className={
                        value.noticeType == "Instant"
                          ? "colorImportantOld disableForm"
                          : "colorInfoOld disableForm"
                      }
                    >
                      <span>
                        {viewDate ? (
                          <DraftsOutlinedIcon />
                        ) : (
                          <MarkEmailUnreadOutlinedIcon />
                        )}
                      </span>
                      {pinColor ? (
                        <span
                          className={
                            value.noticeType == "Instant"
                              ? "colorImportantOld"
                              : "colorInfoOld"
                          }
                        >
                          {" "}
                          <PushPinIcon />
                        </span>
                      ) : value.isPinned == false ? (
                        <PushPinOutlinedIcon style={{ color: "#9AAFC4" }} />
                      ) : (
                        <PushPinOutlinedIcon style={{ color: "#9AAFC4" }} />
                      )}
                    </div>
                  )}
                </Stack>
              </React.Fragment>
            }
          />
        </ListItem>
        <ModalNotice
          openModel={openModal}
          setOpenModal={setOpenModal}
          detail={modalDetail}
          FNsetPinColor={setPinColor}
          FNsetViewDate={FNsetViewDate}
          isLogin={false}
        />
      </Grid>
    </>
  );
}
